module.exports = __webpack_public_path__ + "img/dashboard_white.7c1c4b2d.svg";